// src/pages/admin/LMPillarTable.js
import React, { useEffect, useState } from 'react';
import api from "../api";
import '../pages/admin/AdminDoctorView.css';

export default function LMPillarTable({ collection }) {
  const [entries, setEntries] = useState([]);
  const [newEntry, setNewEntry] = useState({ date: '', name: '', note: '', file: null });
  const [editingId, setEditingId] = useState(null);
  const [editEntry, setEditEntry] = useState({ name: '', note: '', file: null });
  const [clients, setClients] = useState([]);
  const [showSendModal, setShowSendModal] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);
  const [sendingEntryId, setSendingEntryId] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchEntries();
  }, [collection]);

  const fetchClients = async () => {
    try {
      const res = await api.get(`/admin/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Fetched clients:", res.data);
      setClients(res.data || []);
    } catch (err) {
      console.error("Failed to fetch clients", err);
    }
  };

  const handleSendToClients = async () => {
    try {
      await api.post(`/admin/lm/send-to/${collection}/${sendingEntryId}`, {
        emails: selectedClients
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowSendModal(false);
      setSelectedClients([]);
      alert("Entry sent!");
    } catch (err) {
      console.error("Failed to send entry", err);
      alert("Failed to send entry.");
    }
  };

  const fetchEntries = async () => {
    try {
      const res = await api.get(`/admin/lm/${collection}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEntries(res.data.entries || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileChange = (e) => {
    setNewEntry({ ...newEntry, file: e.target.files[0] });
  };

  const handleDeleteEntry = async (id) => {
    if (!window.confirm("Are you sure you want to delete this entry?")) return;

    try {
      await api.delete(`/admin/lm/${collection}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchEntries();
    } catch (err) {
      console.error(err);
      alert("Failed to delete entry.");
    }
  };

  const handleSaveEdit = async (id) => {
    const formData = new FormData();
    formData.append("name", editEntry.name);
    formData.append("note", editEntry.note);
    if (editEntry.file) formData.append("file", editEntry.file);

    try {
      await api.patch(`/admin/lm/${collection}/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setEditingId(null);
      fetchEntries();
    } catch (err) {
      console.error(err);
      alert("Failed to update entry.");
    }
  };

  const handleAddEntry = async () => {
    if (!newEntry.name) {
      alert("Name is required.");
      return;
    }

    const formData = new FormData();
    formData.append("name", newEntry.name);
    formData.append("note", newEntry.note);
    if (newEntry.file) formData.append("file", newEntry.file);

    try {
      await api.post(`/admin/lm/${collection}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setNewEntry({ name: '', note: '', file: null });
      fetchEntries();
    } catch (err) {
      console.error(err);
      alert("Failed to add entry.");
    }
  };

  return (
    <div className="lm-table">
      <h3>{collection.replace("lm_", "").toUpperCase()} Records</h3>
      <table className="lm-data-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Note</th>
            <th>File</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.id}>
              <td>{entry.date}</td>
              <td>
                {editingId === entry.id ? (
                  <input
                    type="text"
                    value={editEntry.name}
                    onChange={(e) => setEditEntry({ ...editEntry, name: e.target.value })}
                  />
                ) : (
                  entry.name
                )}
              </td>
              <td>
                {editingId === entry.id ? (
                  <input
                    type="text"
                    value={editEntry.note}
                    onChange={(e) => setEditEntry({ ...editEntry, note: e.target.value })}
                  />
                ) : (
                  entry.note
                )}
              </td>
              <td>
                {entry.file_url ? (
                  <a href={entry.file_url} target="_blank" rel="noreferrer">{entry.filename}</a>
                ) : "—"}
                {editingId === entry.id && (
                  <input type="file" onChange={(e) => setEditEntry({ ...editEntry, file: e.target.files[0] })} />
                )}
              </td>
              <td>
                {editingId === entry.id ? (
                  <>
                    <button className='send-button' onClick={() => handleSaveEdit(entry.id)}>Save</button>
                    <button className="delete-button" onClick={() => setEditingId(null)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <button className='send-button' onClick={() => {
                      setSendingEntryId(entry.id);
                      setShowSendModal(true);
                      fetchClients();
                    }}>
                      Send To
                    </button>

                    {showSendModal && (
                      <div className="modal">
                        <h4>Select Clients to Send Entry</h4>
                        {clients.length === 0 ? (
                          <p>No clients available</p>
                        ) : (
                          clients.map((client) => (
                            <label key={client.email} style={{ display: 'block', marginBottom: '5px' }}>
                              <input
                                className='check-box'
                                type="checkbox"
                                value={client.email}
                                checked={selectedClients.includes(client.email)}
                                onChange={(e) => {
                                  const email = client.email;
                                  if (e.target.checked) {
                                    setSelectedClients((prev) => [...prev, email]);
                                  } else {
                                    setSelectedClients((prev) => prev.filter(c => c !== email));
                                  }
                                }}
                              />
                              {client.name} ({client.email})
                            </label>
                          ))
                        )}
                        <button onClick={handleSendToClients}>Send</button>
                        <button onClick={() => setShowSendModal(false)}>Cancel</button>
                      </div>
                    )}


                    <button className='edit-button' onClick={() => {
                      setEditingId(entry.id);
                      setEditEntry({
                        name: entry.name,
                        note: entry.note,
                        file: null
                      });
                    }}>
                      Edit
                    </button>
                    <button className="delete-button" onClick={() => handleDeleteEntry(entry.id)}>Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="lm-add-entry">
        <h4>Add New Entry</h4>
        <input
          type="text"
          placeholder="Name"
          value={newEntry.name}
          onChange={(e) => setNewEntry({ ...newEntry, name: e.target.value })}
        />
        <input
          type="text"
          placeholder="Note"
          value={newEntry.note}
          onChange={(e) => setNewEntry({ ...newEntry, note: e.target.value })}
        />
        <input type="file" onChange={handleFileChange} />
        <button className='add-button' onClick={handleAddEntry}>Add</button>
      </div>
    </div>
  );
}
